import React from 'react';
import PropTypes from 'prop-types';

import { BaseButton } from '../base-button';
import styles from './SimpleButton.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const SimpleButton = props => (
  <BaseButton
    {...props}
    className={[styles.container, props.className].join(' ')}
    disabledClassName={styles.disabled}
    pressedClassName={styles.pressed}
  />
);

SimpleButton.propTypes = IPropTypes;
SimpleButton.defaultProps = defaultProps;

export { SimpleButton };



// WEBPACK FOOTER //
// ./src/common/simple-button/SimpleButton.jsx